import React, { useState, useEffect , useRef} from "react";
import { Container, Row, Col, Table, Button, Form, FormControl, Modal } from "react-bootstrap";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import { decryptId } from "../../utils/helpers";

const API_URL = process.env.REACT_APP_API_URL;

export default function FertilizationRate({ source, sampleId }) {

    // const labelBox = {
    //     backgroundColor: "#DFF5F1",
    //     padding: "10px 20px",
    //     borderRadius: "8px",
    //     border: "2px solid #4DB6AC",
    //     fontWeight: "bold",
    //     fontSize: "18px",
    //     width: "260px",
    //     textAlign: "center"
    // };


    const { user } = useAuth();
    ///////////////////////////
    const [showModal, setShowModal] = useState(false);
    const [password, setPassword] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [error, setError] = useState("");
    ////////////////////////////

    const [autoSaveAfterDelete, setAutoSaveAfterDelete] = useState(false);

    const [oocytesObtained, setOocytesObtained] = useState("");
    const [mi, setMi] = useState("");
    const [mii, setMii] = useState("");
    const [oocytesFertilized, setOocytesFertilized] = useState("");
    const [embryosTransferred, setEmbryosTransferred] = useState("");
    const [grade, setGrade] = useState("");
    const [transferType, setTransferType] = useState("");
    const [remark, setRemark] = useState("");

    const [followup14daysData, setFollowup14daysData] = useState(null);

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    // ✅ Dynamic table rows for dates
    const [rows, setRows] = useState([
        { id: Date.now(), day0: "", day1: "", day3: "" }
    ]);
    // const transferMap = {
    //     "1": "Smooth",
    //     "2": "Difficult",
    //     "3": "Data_Not_Available"
    // };

    const decodedId = decodeURIComponent(sampleId);
    const id_sample = decryptId(decodedId);
    const alertShown = useRef(false);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios.get(`${API_URL}/get_fertilizationRate_data/${id_sample}`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { followup_type: source }
        })
            .then((res) => {
                // console.log("FULL API RESPONSE:", res);
                // console.log("followup14daysData =>", res.data.followup14daysData);
                const data = res.data.followup14daysData;
                if (!data) return;
                setFollowup14daysData(data);
                setOocytesObtained(data.oocytes_obtained ?? "");
                setMi(data.mi_value ?? "");
                setMii(data.Mii_value ?? "");
                setOocytesFertilized(data.oocytes_fertilized ?? "");
                setEmbryosTransferred(data.embryos_transferred ?? "");
                // setTransferType(data.transfer === "1" ? "Smooth" : "Difficult");
                setTransferType(data.transfer?.trim() || "");
                setGrade(data.grade ?? "");
                setRemark(data.remark ?? "");

                // ✅ THIS IS MISSING IN YOUR CODE
                if (Array.isArray(data.dates) && data.dates.length > 0) {
                    setRows(
                        data.dates.map(row => ({
                            id: Date.now() + Math.random(),
                            day0: row.day0 ?? "",
                            day1: row.day1 ?? "",
                            day3: row.day3 ?? ""
                        }))
                    );
                }
            })
            .catch(console.error);
    }, [id_sample, source]);

    console.log(followup14daysData);
    const addRow = () => {
        setRows([...rows, { id: Date.now(), day0: "", day1: "", day3: "" }]);
    };

    const removeRow = (id) => {
        if (rows.length === 0) return;

        const confirmDelete = window.confirm("Do you want to delete?");
        if (confirmDelete) {
            setRows(rows.filter(r => r.id !== id));
        }
    };

    const handleDateChange = (id, field, value) => {
        setRows(rows.map(row =>
            row.id === id ? { ...row, [field]: value } : row
        ));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const token = localStorage.getItem("token");

        const payload = {
            sample_id: id_sample,
            followup_type: source,

            oocytes_obtained: oocytesObtained || null,
            mi_value: mi || null,
            Mii_value: mii || null,
            oocytes_fertilized: oocytesFertilized || null,
            embryos_transferred: embryosTransferred || null,
            grade: grade || null,
            transfer: transferType || null,
            remark: remark || null,

            dates: rows.map(r => ({
                day0: r.day0 || null,
                day1: r.day1 || null,
                day2: r.day3 || null
            }))
        };

        console.log("SAVE PAYLOAD =>", payload);

        try {
            const res = await axios.post(
                `${API_URL}/add_fertilizationRate_data/${id_sample}`,
                payload,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // alert(res.data.message || "Saved successfully");

            setSuccessMsg(
                res.data.message || `Clinical Pregnancy data ${source} saved successfully`
            ); setErrorMsg("");

            setTimeout(() => setSuccessMsg(""), 1000);

        } catch (err) {
            console.error(err);
            // alert("Error saving fertilization data");

            setErrorMsg("Error saving fertilization data");

            setTimeout(() => setErrorMsg(""), 1000);

        }
    };
    const openPasswordModal = (literature_id) => {
        setSelectedId(literature_id);
        setPassword("");
        setError("");
        setShowModal(true);
    };


    const verifyPassword = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${API_URL}/verify-password`,
                { password, uid: user?.uid },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (res.data.success) {
                setShowModal(false);

                removeRow(selectedId);
                setAutoSaveAfterDelete(true);

            } else {
                setError("Incorrect password");
            }
        } catch (err) {
            setError("Incorrect password");
        }
    };
    useEffect(() => {
        if (autoSaveAfterDelete) {
            const fakeEvent = { preventDefault: () => { } };
            handleSubmit(fakeEvent);   // call API
            setAutoSaveAfterDelete(false);
        }
    }, [rows]);
    return (
        <div style={{ minHeight: "70vh" }}>

            <h6 style={{ textAlign: "left" }}>
                Fertilization Rate
            </h6>
            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}
            <Container className="mt-4">
                <Form onSubmit={handleSubmit}>

                    <Row className="mb-3" style={{ alignItems: "center" }}>

                        {/* Oocytes Obtained */}
                        <Col xs={4} md={3}>
                            <div
                                style={{
                                    backgroundColor: "#DFF5F1",
                                    padding: "8px 12px",
                                    border: "1px solid #4DB6AC",
                                    borderRadius: "4px",
                                    textAlign: "right",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold"
                                }}
                            >
                                Oocytes Obtained
                            </div>
                        </Col>
                        <Col xs={2} md={2}>
                            <Form.Control
                                value={oocytesObtained}
                                onChange={e => setOocytesObtained(e.target.value)}
                                style={{
                                    backgroundColor: "#fff",
                                    border: "1px solid #ccc"
                                }}
                            />
                        </Col>

                        {/* M I */}
                        <Col xs={2} md={1}>
                            <div
                                style={{
                                    backgroundColor: "#DFF5F1",
                                    padding: "8px 12px",
                                    border: "1px solid #4DB6AC",
                                    borderRadius: "4px",
                                    textAlign: "right",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold"
                                }}
                            >
                                M I
                            </div>
                        </Col>
                        <Col xs={2} md={2}>
                            <Form.Control
                                value={mi}
                                onChange={e => setMi(e.target.value)}
                                style={{
                                    backgroundColor: "#fff",
                                    border: "1px solid #ccc"
                                }}
                            />
                        </Col>

                        {/* M II */}
                        <Col xs={2} md={2}>
                            <div
                                style={{
                                    backgroundColor: "#DFF5F1",
                                    padding: "8px 12px",
                                    border: "1px solid #4DB6AC",
                                    borderRadius: "4px",
                                    textAlign: "right",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold"
                                }}
                            >
                                M II
                            </div>
                        </Col>
                        <Col xs={2} md={2}>
                            <Form.Control
                                value={mii}
                                onChange={e => setMii(e.target.value)}
                                style={{
                                    backgroundColor: "#fff",
                                    border: "1px solid #ccc"
                                }}
                            />
                        </Col>

                    </Row>


                    {/* ✅ Date Table */}
                    <Row className="my-4">
                        <Col>
                            <Table bordered striped>
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: "#DFF5F1" }}>Sr No</th>
                                        <th style={{ backgroundColor: "#DFF5F1" }}>Day 0 (ICSI)</th>
                                        <th style={{ backgroundColor: "#DFF5F1" }}>Day 1 (Fertilization)</th>
                                        <th style={{ backgroundColor: "#DFF5F1" }}>Day 3 (Embryo)</th>
                                        <th style={{ backgroundColor: "#DFF5F1" }}>
                                            <Button onClick={addRow}>+</Button>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={row.id}>
                                            <td>{index + 1}</td>

                                            <td>
                                                <Form.Control
                                                    type="date"
                                                    value={row.day0}
                                                    onChange={e => handleDateChange(row.id, "day0", e.target.value)}
                                                />
                                            </td>

                                            <td>
                                                <Form.Control
                                                    type="date"
                                                    value={row.day1}
                                                    onChange={e => handleDateChange(row.id, "day1", e.target.value)}
                                                />
                                            </td>

                                            <td>
                                                <Form.Control
                                                    type="date"
                                                    value={row.day3}
                                                    onChange={e => handleDateChange(row.id, "day3", e.target.value)}
                                                />
                                            </td>

                                            <td>
                                                <Button variant="danger" onClick={() => openPasswordModal(row.id)}>-</Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>

                    {/* First Row */}
                    <Row className="mb-3" style={{ alignItems: "center" }}>
                        {/* Oocytes Fertilized */}
                        <Col xs={6} md={3}>
                            <div
                                style={{
                                    backgroundColor: "#DFF5F1",
                                    padding: "8px 12px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    textAlign: "right",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold"
                                }}
                            >
                                Oocytes Fertilized
                            </div>
                        </Col>
                        <Col xs={6} md={3}>
                            <Form.Control
                                value={oocytesFertilized}
                                onChange={e => setOocytesFertilized(e.target.value)}
                                style={{ backgroundColor: "#fff", border: "1px solid #ccc" }}
                            />
                        </Col>

                        {/* Embryos Transferred */}
                        <Col xs={6} md={3}>
                            <div
                                style={{
                                    backgroundColor: "#DFF5F1",
                                    padding: "8px 12px",
                                    border: "1px solid #4DB6AC",
                                    borderRadius: "4px",
                                    textAlign: "right",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold"
                                }}
                            >
                                Embryos Transferred
                            </div>
                        </Col>
                        <Col xs={6} md={3}>
                            <Form.Control
                                value={embryosTransferred}
                                onChange={e => setEmbryosTransferred(e.target.value)}
                                style={{ backgroundColor: "#fff", border: "1px solid #ccc" }}
                            />
                        </Col>
                    </Row>

                    {/* Second Row */}
                    <Row className="mb-3" style={{ alignItems: "center" }}>
                        {/* Grade */}
                        <Col xs={6} md={3}>
                            <div
                                style={{
                                    backgroundColor: "#DFF5F1",
                                    padding: "8px 12px",
                                    border: "1px solid #4DB6AC",
                                    borderRadius: "4px",
                                    textAlign: "right",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold"
                                }}
                            >
                                Grade
                            </div>
                        </Col>
                        <Col xs={6} md={3}>
                            <Form.Control
                                value={grade}
                                onChange={e => setGrade(e.target.value)}
                                style={{ backgroundColor: "#fff", border: "1px solid #ccc" }}
                            />
                        </Col>

                        {/* Transfer */}
                        <Col xs={6} md={3}>
                            <div
                                style={{
                                    backgroundColor: "#DFF5F1",
                                    padding: "8px 12px",
                                    border: "1px solid #4DB6AC",
                                    borderRadius: "4px",
                                    textAlign: "right",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold"
                                }}
                            >
                                Transfer
                            </div>
                        </Col>
                        <Col xs={6} md={3}>
                            <div>
                                <Form.Check
                                    inline
                                    label="Smooth"
                                    type="radio"
                                    checked={transferType === "Smooth"}
                                    onChange={() => setTransferType("Smooth")}
                                />
                                <Form.Check
                                    inline
                                    label="Difficult"
                                    type="radio"
                                    checked={transferType === "Difficult"}
                                    onChange={() => setTransferType("Difficult")}
                                />
                                <Form.Check
                                    inline
                                    label="Data Not Available"
                                    type="radio"
                                    checked={transferType === "Data_Not_Available"}
                                    onChange={() => setTransferType("Data_Not_Available")}
                                />
                            </div>
                        </Col>
                    </Row>


                    <FormControl
                        as="textarea"
                        rows={2}
                        placeholder="Enter remarks"
                        value={remark}
                        onChange={e => setRemark(e.target.value)}
                    />

                    <div className="text-center mt-4">
                        <Button type="submit">Save</Button>
                    </div>

                </Form>
                <Modal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    centered
                    backdrop="static"
                    keyboard={false}
                    dialogClassName="soft-modal"
                >
                    <Modal.Header closeButton style={{ borderBottom: "none" }}>
                        <Modal.Title style={{ fontWeight: 600, fontSize: "1.3rem" }}>
                            Confirm Password
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{ padding: "2rem 2rem 1rem 2rem" }}>
                        <Form.Group>
                            <Form.Label style={{ fontWeight: 500, fontSize: "0.95rem", color: "#555" }}>
                                Enter your password
                            </Form.Label>
                            <Form.Control
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="" autoComplete="off"
                                style={{
                                    borderRadius: "12px",
                                    border: "1px solid #ddd",
                                    padding: "10px 15px",
                                    fontSize: "0.95rem",
                                    boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
                                }}
                            />
                        </Form.Group>
                        {error && (
                            <p
                                className="text-danger mt-2"
                                style={{ fontSize: "0.9rem", fontWeight: 500 }}
                            >
                                {error}
                            </p>
                        )}
                    </Modal.Body>

                    <Modal.Footer style={{ borderTop: "none", padding: "1rem 2rem 2rem 2rem" }}>
                        <Button
                            variant="outline-secondary"
                            onClick={() => setShowModal(false)}
                            style={{
                                borderRadius: "10px",
                                padding: "8px 18px",
                                fontWeight: 500,
                                boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={verifyPassword}
                            style={{
                                borderRadius: "10px",
                                padding: "8px 20px",
                                fontWeight: 600,
                                background: "linear-gradient(135deg,#6a9fff,#5a86ff)",
                                border: "none",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                            }}
                        >
                            Verify
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        </div>
    );
}
